<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'visitreasons') {
            next({ name: 'motivo-visita-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'visitreasons') {
            this.$router.push({ name: 'motivo-visita-list' });
        }
    },
};
</script>
